export const COACH_TASK_ACTION_EVENT = "disciplio:coach-task-action";

export type CoachTaskActionDetail = {
  affectedDates: string[];
};

/** Notify the shared Disciplio state after a task action executed inside Coach. */
export function notifyCoachTaskAction(affectedDates: string[]) {
  if (typeof window === "undefined") return;
  const dates = [
    ...new Set(
      affectedDates.filter((date) => /^\d{4}-\d{2}-\d{2}$/.test(date))
    ),
  ];
  window.dispatchEvent(
    new CustomEvent<CoachTaskActionDetail>(COACH_TASK_ACTION_EVENT, {
      detail: { affectedDates: dates },
    })
  );
}
